import Aura from '@primeuix/themes/material';
import { definePreset } from '@primeuix/themes';

const components = {
  toast:{
    colorScheme: {
      light: {
        info: {
          detailColor: '	#303030'
        },
        warn: {
          detailColor: '	#303030'
        },
        error: {
          detailColor: '	#303030'
        },
        success: {
          detailColor: '	#303030'
        }
      },
      dark: {
                  info: {
          detailColor: '	#303030'
        },
        warn: {
          detailColor: '	#303030'
        },
        error: {
          detailColor: '	#303030'
        },
        success: {
          detailColor: '	#303030'
        }
      }
    },
  },
  inputtext:{
    colorScheme: {
      light: {
        root: {
          background: 'transparent',
        }
      },
      dark: {
        root: {
          background: 'transparent',
        }
      }
    }
  },
  textarea:{
    colorScheme: {
      light: {
        root: {
          background: 'transparent',
        }
      },
      dark: {
        root: {
          background: 'transparent',
        }
      }
    }
  }
}

export const TealPreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#f0fdfa',
          100: '#ccfbf1',
          200: '#99f6e4',
          300: '#5eead4',
          400: '#2dd4bf',
          500: '#14b8a6',
          600: '#0d9488',
          700: '#0f766e',
          800: '#115e59',
          900: '#134e4a',
          950: '#0f4337'
        },
        surface: {
          0: '#ffffff',
          50: '#f0fdfa',
          100: '#ccfbf1',
          200: '#99f6e4',
          300: '#5eead4',
          400: '#2dd4bf',
          500: '#14b8a6',
          600: '#0d9488',
          700: '#0f766e',
          800: '#115e59',
          900: '#134e4a',
          950: '#0f4337'
        }
      },
      dark: {
        primary: {
          50: '#0f4337',
          100: '#134e4a',
          200: '#115e59',
          300: '#0f766e',
          400: '#0d9488',
          500: '#14b8a6',
          600: '#2dd4bf',
          700: '#5eead4',
          800: '#99f6e4',
          900: '#ccfbf1',
          950: '#f0fdfa'
        },
        surface: {
          0: '#000000',
          50: '#0f4337',
          100: '#134e4a',
          200: '#115e59',
          300: '#0f766e',
          400: '#0d9488',
          500: '#14b8a6',
          600: '#2dd4bf',
          700: '#5eead4',
          800: '#99f6e4',
          900: '#ccfbf1',
          950: '#f0fdfa'
        }
      }
    }
  }
});

export const EmeraldPreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#ecfdf5',
          100: '#d1fae5',
          200: '#a7f3d0',
          300: '#6ee7b7',
          400: '#34d399',
          500: '#10b981',
          600: '#059669',
          700: '#047857',
          800: '#065f46',
          900: '#064e3b',
          950: '#022c22'
        },
        surface: {
          0: '#ffffff',
          50: '#ecfdf5',
          100: '#d1fae5',
          200: '#a7f3d0',
          300: '#6ee7b7',
          400: '#34d399',
          500: '#10b981',
          600: '#059669',
          700: '#047857',
          800: '#065f46',
          900: '#064e3b',
          950: '#022c22'
        }
      },
      dark: {
        primary: {
          50: '#022c22',
          100: '#064e3b',
          200: '#065f46',
          300: '#047857',
          400: '#059669',
          500: '#10b981',
          600: '#34d399',
          700: '#6ee7b7',
          800: '#a7f3d0',
          900: '#d1fae5',
          950: '#ecfdf5'
        },
        surface: {
          0: '#000000',
          50: '#022c22',
          100: '#064e3b',
          200: '#065f46',
          300: '#047857',
          400: '#059669',
          500: '#10b981',
          600: '#34d399',
          700: '#6ee7b7',
          800: '#a7f3d0',
          900: '#d1fae5',
          950: '#ecfdf5'
        }
      }
    }
  }
});

export const OrangePreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#fff7ed',
          100: '#ffedd5',
          200: '#fed7aa',
          300: '#fdba74',
          400: '#fb923c',
          500: '#f97316',
          600: '#ea580c',
          700: '#c2410c',
          800: '#9a3412',
          900: '#7c2d12',
          950: '#431407'
        },
        surface: {
          0: '#ffffff',
          50: '#fff7ed',
          100: '#ffedd5',
          200: '#fed7aa',
          300: '#fdba74',
          400: '#fb923c',
          500: '#f97316',
          600: '#ea580c',
          700: '#c2410c',
          800: '#9a3412',
          900: '#7c2d12',
          950: '#431407'
        }
      },
      dark: {
        primary: {
          50: '#431407',
          100: '#7c2d12',
          200: '#9a3412',
          300: '#c2410c',
          400: '#ea580c',
          500: '#f97316',
          600: '#fb923c',
          700: '#fdba74',
          800: '#fed7aa',
          900: '#ffedd5',
          950: '#fff7ed'
        },
        surface: {
          0: '#000000',
          50: '#431407',
          100: '#7c2d12',
          200: '#9a3412',
          300: '#c2410c',
          400: '#ea580c',
          500: '#f97316',
          600: '#fb923c',
          700: '#fdba74',
          800: '#ffedd5',
          900: '#fff7ed',
          950: '#ffffff'
        }
      }
    }
  }
});

// Red Preset
export const RedPreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#fef2f2',
          100: '#fee2e2',
          200: '#fecaca',
          300: '#fca5a5',
          400: '#f87171',
          500: '#ef4444',
          600: '#dc2626',
          700: '#b91c1c',
          800: '#991b1b',
          900: '#7f1d1d',
          950: '#450a0a'
        },
        surface: {
          0: '#ffffff',
          50: '#fef2f2',
          100: '#fee2e2',
          200: '#fecaca',
          300: '#fca5a5',
          400: '#f87171',
          500: '#ef4444',
          600: '#dc2626',
          700: '#b91c1c',
          800: '#991b1b',
          900: '#7f1d1d',
          950: '#450a0a'
        }
      },
      dark: {
        primary: {
          50: '#450a0a',
          100: '#7f1d1d',
          200: '#991b1b',
          300: '#b91c1c',
          400: '#dc2626',
          500: '#ef4444',
          600: '#f87171',
          700: '#fca5a5',
          800: '#fecaca',
          900: '#fee2e2',
          950: '#fef2f2'
        },
        surface: {
          0: '#000000',
          50: '#450a0a',
          100: '#7f1d1d',
          200: '#991b1b',
          300: '#b91c1c',
          400: '#dc2626',
          500: '#ef4444',
          600: '#f87171',
          700: '#fca5a5',
          800: '#fecaca',
          900: '#fee2e2',
          950: '#ffffff'
        }
      }
    }
  }
});

// Blue Preset
export const BluePreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#eff6ff',
          100: '#dbeafe',
          200: '#bfdbfe',
          300: '#93c5fd',
          400: '#60a5fa',
          500: '#3b82f6',
          600: '#2563eb',
          700: '#1d4ed8',
          800: '#1e40af',
          900: '#1e3a8a',
          950: '#172554'
        },
        surface: {
          0: '#ffffff',
          50: '#eff6ff',
          100: '#dbeafe',
          200: '#bfdbfe',
          300: '#93c5fd',
          400: '#60a5fa',
          500: '#3b82f6',
          600: '#2563eb',
          700: '#1d4ed8',
          800: '#1e40af',
          900: '#1e3a8a',
          950: '#172554'
        }
      },
      dark: {
        primary: {
          50: '#172554',
          100: '#1e3a8a',
          200: '#1e40af',
          300: '#1d4ed8',
          400: '#2563eb',
          500: '#3b82f6',
          600: '#60a5fa',
          700: '#93c5fd',
          800: '#bfdbfe',
          900: '#dbeafe',
          950: '#eff6ff'
        },
        surface: {
          0: '#000000',
          50: '#172554',
          100: '#1e3a8a',
          200: '#1e40af',
          300: '#1d4ed8',
          400: '#2563eb',
          500: '#3b82f6',
          600: '#60a5fa',
          700: '#93c5fd',
          800: '#bfdbfe',
          900: '#dbeafe',
          950: '#ffffff'
        }
      }
    }
  }
});

// Purple Preset
export const PurplePreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#faf5ff',
          100: '#f3e8ff',
          200: '#e9d5ff',
          300: '#d8b4fe',
          400: '#c084fc',
          500: '#a855f7',
          600: '#9333ea',
          700: '#7c3aed',
          800: '#6b21a8',
          900: '#581c87',
          950: '#3b0764'
        },
        surface: {
          0: '#ffffff',
          50: '#faf5ff',
          100: '#f3e8ff',
          200: '#e9d5ff',
          300: '#d8b4fe',
          400: '#c084fc',
          500: '#a855f7',
          600: '#9333ea',
          700: '#7c3aed',
          800: '#6b21a8',
          900: '#581c87',
          950: '#3b0764'
        }
      },
      dark: {
        primary: {
          50: '#3b0764',
          100: '#581c87',
          200: '#6b21a8',
          300: '#7c3aed',
          400: '#9333ea',
          500: '#a855f7',
          600: '#c084fc',
          700: '#d8b4fe',
          800: '#e9d5ff',
          900: '#f3e8ff',
          950: '#faf5ff'
        },
        surface: {
          0: '#000000',
          50: '#3b0764',
          100: '#581c87',
          200: '#6b21a8',
          300: '#7c3aed',
          400: '#9333ea',
          500: '#a855f7',
          600: '#c084fc',
          700: '#d8b4fe',
          800: '#e9d5ff',
          900: '#f3e8ff',
          950: '#ffffff'
        }
      }
    }
  }
});

// Pink Preset
export const PinkPreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#fdf2f8',
          100: '#fce7f3',
          200: '#fbcfe8',
          300: '#f9a8d4',
          400: '#f472b6',
          500: '#ec4899',
          600: '#db2777',
          700: '#be185d',
          800: '#9d174d',
          900: '#831843',
          950: '#500724'
        },
        surface: {
          0: '#ffffff',
          50: '#fdf2f8',
          100: '#fce7f3',
          200: '#fbcfe8',
          300: '#f9a8d4',
          400: '#f472b6',
          500: '#ec4899',
          600: '#db2777',
          700: '#be185d',
          800: '#9d174d',
          900: '#831843',
          950: '#500724'
        }
      },
      dark: {
        primary: {
          50: '#500724',
          100: '#831843',
          200: '#9d174d',
          300: '#be185d',
          400: '#db2777',
          500: '#ec4899',
          600: '#f472b6',
          700: '#f9a8d4',
          800: '#fbcfe8',
          900: '#fce7f3',
          950: '#fdf2f8'
        },
        surface: {
          0: '#000000',
          50: '#500724',
          100: '#831843',
          200: '#9d174d',
          300: '#be185d',
          400: '#db2777',
          500: '#ec4899',
          600: '#f472b6',
          700: '#f9a8d4',
          800: '#fbcfe8',
          900: '#fce7f3',
          950: '#ffffff'
        }
      }
    }
  }
});

// Indigo Preset
export const IndigoPreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#eef2ff',
          100: '#e0e7ff',
          200: '#c7d2fe',
          300: '#a5b4fc',
          400: '#818cf8',
          500: '#6366f1',
          600: '#4f46e5',
          700: '#4338ca',
          800: '#3730a3',
          900: '#312e81',
          950: '#1e1b4b'
        },
        surface: {
          0: '#ffffff',
          50: '#eef2ff',
          100: '#e0e7ff',
          200: '#c7d2fe',
          300: '#a5b4fc',
          400: '#818cf8',
          500: '#6366f1',
          600: '#4f46e5',
          700: '#4338ca',
          800: '#3730a3',
          900: '#312e81',
          950: '#1e1b4b'
        }
      },
      dark: {
        primary: {
          50: '#1e1b4b',
          100: '#312e81',
          200: '#3730a3',
          300: '#4338ca',
          400: '#4f46e5',
          500: '#6366f1',
          600: '#818cf8',
          700: '#a5b4fc',
          800: '#c7d2fe',
          900: '#e0e7ff',
          950: '#eef2ff'
        },
        surface: {
          0: '#000000',
          50: '#1e1b4b',
          100: '#312e81',
          200: '#3730a3',
          300: '#4338ca',
          400: '#4f46e5',
          500: '#6366f1',
          600: '#818cf8',
          700: '#a5b4fc',
          800: '#c7d2fe',
          900: '#e0e7ff',
          950: '#ffffff'
        }
      }
    }
  }
});

// Cyan Preset
export const CyanPreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#ecfeff',
          100: '#cffafe',
          200: '#a5f3fc',
          300: '#67e8f9',
          400: '#22d3ee',
          500: '#06b6d4',
          600: '#0891b2',
          700: '#0e7490',
          800: '#155e75',
          900: '#164e63',
          950: '#083344'
        },
        surface: {
          0: '#ffffff',
          50: '#ecfeff',
          100: '#cffafe',
          200: '#a5f3fc',
          300: '#67e8f9',
          400: '#22d3ee',
          500: '#06b6d4',
          600: '#0891b2',
          700: '#0e7490',
          800: '#155e75',
          900: '#164e63',
          950: '#083344'
        }
      },
      dark: {
        primary: {
          50: '#083344',
          100: '#164e63',
          200: '#155e75',
          300: '#0e7490',
          400: '#0891b2',
          500: '#06b6d4',
          600: '#22d3ee',
          700: '#67e8f9',
          800: '#a5f3fc',
          900: '#cffafe',
          950: '#ecfeff'
        },
        surface: {
          0: '#000000',
          50: '#083344',
          100: '#164e63',
          200: '#155e75',
          300: '#0e7490',
          400: '#0891b2',
          500: '#06b6d4',
          600: '#22d3ee',
          700: '#67e8f9',
          800: '#a5f3fc',
          900: '#cffafe',
          950: '#ffffff'
        }
      }
    }
  }
});

// Yellow Preset
export const YellowPreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#fefce8',
          100: '#fef9c3',
          200: '#fef08a',
          300: '#fde047',
          400: '#facc15',
          500: '#eab308',
          600: '#ca8a04',
          700: '#a16207',
          800: '#854d0e',
          900: '#713f12',
          950: '#422006'
        },
        surface: {
          0: '#ffffff',
          50: '#fefce8',
          100: '#fef9c3',
          200: '#fef08a',
          300: '#fde047',
          400: '#facc15',
          500: '#eab308',
          600: '#ca8a04',
          700: '#a16207',
          800: '#854d0e',
          900: '#713f12',
          950: '#422006'
        }
      },
      dark: {
        primary: {
          50: '#422006',
          100: '#713f12',
          200: '#854d0e',
          300: '#a16207',
          400: '#ca8a04',
          500: '#eab308',
          600: '#facc15',
          700: '#fde047',
          800: '#fef08a',
          900: '#fef9c3',
          950: '#fefce8'
        },
        surface: {
          0: '#000000',
          50: '#422006',
          100: '#713f12',
          200: '#854d0e',
          300: '#a16207',
          400: '#ca8a04',
          500: '#eab308',
          600: '#facc15',
          700: '#fde047',
          800: '#fef08a',
          900: '#fef9c3',
          950: '#ffffff'
        }
      }
    }
  }
});

// Slate Preset (Neutral Gray)
export const SlatePreset = definePreset(Aura, {
  components:{
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
          950: '#020617'
        },
        surface: {
          0: '#ffffff',
          50: '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
          950: '#020617'
        }
      },
      dark: {
        primary: {
          50: '#020617',
          100: '#0f172a',
          200: '#1e293b',
          300: '#334155',
          400: '#475569',
          500: '#64748b',
          600: '#94a3b8',
          700: '#cbd5e1',
          800: '#e2e8f0',
          900: '#f1f5f9',
          950: '#f8fafc'
        },
        surface: {
          0: '#000000',
          50: '#020617',
          100: '#0f172a',
          200: '#1e293b',
          300: '#334155',
          400: '#475569',
          500: '#64748b',
          600: '#94a3b8',
          700: '#cbd5e1',
          800: '#e2e8f0',
          900: '#f1f5f9',
          950: '#ffffff'
        }
      }
    }
  }
});

// Rose Preset
export const RosePreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#fff1f2', 100: '#ffe4e6', 200: '#fecdd3', 300: '#fda4af', 400: '#fb7185',
          500: '#f43f5e', 600: '#e11d48', 700: '#be123c', 800: '#9f1239', 900: '#881337', 950: '#4c0017'
        },
        surface: { 0: '#ffffff', 50: '#fff1f2', 100: '#ffe4e6', 200: '#fecdd3', 300: '#fda4af', 400: '#fb7185', 500: '#f43f5e', 600: '#e11d48', 700: '#be123c', 800: '#9f1239', 900: '#881337', 950: '#4c0017' }
      },
      dark: {
        primary: { 50: '#4c0017', 100: '#881337', 200: '#9f1239', 300: '#be123c', 400: '#e11d48', 500: '#f43f5e', 600: '#fb7185', 700: '#fda4af', 800: '#fecdd3', 900: '#ffe4e6', 950: '#fff1f2' },
        surface: { 0: '#000000', 50: '#4c0017', 100: '#881337', 200: '#9f1239', 300: '#be123c', 400: '#e11d48', 500: '#f43f5e', 600: '#fb7185', 700: '#fda4af', 800: '#fecdd3', 900: '#ffe4e6', 950: '#ffffff' }
      }
    }
  }
});

// Fuchsia Preset
export const FuchsiaPreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: { 50: '#fdf4ff', 100: '#fae8ff', 200: '#f5d0fe', 300: '#f0abfc', 400: '#e879f9', 500: '#d946ef', 600: '#c026d3', 700: '#a21caf', 800: '#86198f', 900: '#701a75', 950: '#4a044e' },
        surface: { 0: '#ffffff', 50: '#fdf4ff', 100: '#fae8ff', 200: '#f5d0fe', 300: '#f0abfc', 400: '#e879f9', 500: '#d946ef', 600: '#c026d3', 700: '#a21caf', 800: '#86198f', 900: '#701a75', 950: '#4a044e' }
      },
      dark: {
        primary: { 50: '#4a044e', 100: '#701a75', 200: '#86198f', 300: '#a21caf', 400: '#c026d3', 500: '#d946ef', 600: '#e879f9', 700: '#f0abfc', 800: '#f5d0fe', 900: '#fae8ff', 950: '#fdf4ff' },
        surface: { 0: '#000000', 50: '#4a044e', 100: '#701a75', 200: '#86198f', 300: '#a21caf', 400: '#c026d3', 500: '#d946ef', 600: '#e879f9', 700: '#f0abfc', 800: '#f5d0fe', 900: '#fae8ff', 950: '#ffffff' }
      }
    }
  }
});

// Violet Preset
export const VioletPreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: { 50: '#f5f3ff', 100: '#ede9fe', 200: '#ddd6fe', 300: '#c4b5fd', 400: '#a78bfa', 500: '#8b5cf6', 600: '#7c3aed', 700: '#6d28d9', 800: '#5b21b6', 900: '#4c1d95', 950: '#2e1065' },
        surface: { 0: '#ffffff', 50: '#f5f3ff', 100: '#ede9fe', 200: '#ddd6fe', 300: '#c4b5fd', 400: '#a78bfa', 500: '#8b5cf6', 600: '#7c3aed', 700: '#6d28d9', 800: '#5b21b6', 900: '#4c1d95', 950: '#2e1065' }
      },
      dark: {
        primary: { 50: '#2e1065', 100: '#4c1d95', 200: '#5b21b6', 300: '#6d28d9', 400: '#7c3aed', 500: '#8b5cf6', 600: '#a78bfa', 700: '#c4b5fd', 800: '#ddd6fe', 900: '#ede9fe', 950: '#f5f3ff' },
        surface: { 0: '#000000', 50: '#2e1065', 100: '#4c1d95', 200: '#5b21b6', 300: '#6d28d9', 400: '#7c3aed', 500: '#8b5cf6', 600: '#a78bfa', 700: '#c4b5fd', 800: '#ddd6fe', 900: '#ede9fe', 950: '#ffffff' }
      }
    }
  }
});

// Lime Preset
export const LimePreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: { 50: '#f7fee7', 100: '#ecfccb', 200: '#d9f99d', 300: '#bef264', 400: '#a3e635', 500: '#84cc16', 600: '#65a30d', 700: '#4d7c0f', 800: '#3f6212', 900: '#365314', 950: '#1a2e05' },
        surface: { 0: '#ffffff', 50: '#f7fee7', 100: '#ecfccb', 200: '#d9f99d', 300: '#bef264', 400: '#a3e635', 500: '#84cc16', 600: '#65a30d', 700: '#4d7c0f', 800: '#3f6212', 900: '#365314', 950: '#1a2e05' }
      },
      dark: {
        primary: { 50: '#1a2e05', 100: '#365314', 200: '#3f6212', 300: '#4d7c0f', 400: '#65a30d', 500: '#84cc16', 600: '#a3e635', 700: '#bef264', 800: '#d9f99d', 900: '#ecfccb', 950: '#f7fee7' },
        surface: { 0: '#000000', 50: '#1a2e05', 100: '#365314', 200: '#3f6212', 300: '#4d7c0f', 400: '#65a30d', 500: '#84cc16', 600: '#a3e635', 700: '#bef264', 800: '#d9f99d', 900: '#ecfccb', 950: '#ffffff' }
      }
    }
  }
});

// Amber Preset
export const AmberPreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: { 50:'#fffbeb',100:'#fef3c7',200:'#fde68a',300:'#fcd34d',400:'#fbbf24',500:'#f59e0b',600:'#d97706',700:'#b45309',800:'#92400e',900:'#78350f',950:'#422006' },
        surface: { 0:'#ffffff',50:'#fffbeb',100:'#fef3c7',200:'#fde68a',300:'#fcd34d',400:'#fbbf24',500:'#f59e0b',600:'#d97706',700:'#b45309',800:'#92400e',900:'#78350f',950:'#422006' }
      },
      dark: {
        primary: { 50:'#422006',100:'#78350f',200:'#92400e',300:'#b45309',400:'#d97706',500:'#f59e0b',600:'#fbbf24',700:'#fcd34d',800:'#fde68a',900:'#fef3c7',950:'#fffbeb' },
        surface: { 0:'#000000',50:'#422006',100:'#78350f',200:'#92400e',300:'#b45309',400:'#d97706',500:'#f59e0b',600:'#fbbf24',700:'#fcd34d',800:'#fde68a',900:'#fef3c7',950:'#ffffff' }
      }
    }
  }
});

// Sky Preset
export const SkyPreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {50:'#f0f9ff',100:'#e0f2fe',200:'#bae6fd',300:'#7dd3fc',400:'#38bdf8',500:'#0ea5e9',600:'#0284c7',700:'#0369a1',800:'#075985',900:'#0c4a6e',950:'#082f49'},
        surface: {0:'#ffffff',50:'#f0f9ff',100:'#e0f2fe',200:'#bae6fd',300:'#7dd3fc',400:'#38bdf8',500:'#0ea5e9',600:'#0284c7',700:'#0369a1',800:'#075985',900:'#0c4a6e',950:'#082f49'}
      },
      dark: {
        primary: {50:'#082f49',100:'#0c4a6e',200:'#075985',300:'#0369a1',400:'#0284c7',500:'#0ea5e9',600:'#38bdf8',700:'#7dd3fc',800:'#bae6fd',900:'#e0f2fe',950:'#f0f9ff'},
        surface: {0:'#000000',50:'#082f49',100:'#0c4a6e',200:'#075985',300:'#0369a1',400:'#0284c7',500:'#0ea5e9',600:'#38bdf8',700:'#7dd3fc',800:'#bae6fd',900:'#e0f2fe',950:'#ffffff'}
      }
    }
  }
});

// Stone Preset
export const StonePreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {50:'#fafaf9',100:'#f5f5f4',200:'#e7e5e4',300:'#d6d3d1',400:'#a8a29e',500:'#78716c',600:'#57534e',700:'#44403c',800:'#292524',900:'#1c1917',950:'#0c0a09'},
        surface: {0:'#ffffff',50:'#fafaf9',100:'#f5f5f4',200:'#e7e5e4',300:'#d6d3d1',400:'#a8a29e',500:'#78716c',600:'#57534e',700:'#44403c',800:'#292524',900:'#1c1917',950:'#0c0a09'}
      },
      dark: {
        primary: {50:'#0c0a09',100:'#1c1917',200:'#292524',300:'#44403c',400:'#57534e',500:'#78716c',600:'#a8a29e',700:'#d6d3d1',800:'#e7e5e4',900:'#f5f5f4',950:'#fafaf9'},
        surface: {0:'#000000',50:'#0c0a09',100:'#1c1917',200:'#292524',300:'#44403c',400:'#57534e',500:'#78716c',600:'#a8a29e',700:'#d6d3d1',800:'#e7e5e4',900:'#f5f5f4',950:'#ffffff'}
      }
    }
  }
});

// Neutral Preset
export const NeutralPreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {50:'#fafafa',100:'#f5f5f5',200:'#e5e5e5',300:'#d4d4d4',400:'#a3a3a3',500:'#737373',600:'#525252',700:'#404040',800:'#262626',900:'#171717',950:'#0a0a0a'},
        surface: {0:'#ffffff',50:'#fafafa',100:'#f5f5f5',200:'#e5e5e5',300:'#d4d4d4',400:'#a3a3a3',500:'#737373',600:'#525252',700:'#404040',800:'#262626',900:'#171717',950:'#0a0a0a'}
      },
      dark: {
        primary: {50:'#0a0a0a',100:'#171717',200:'#262626',300:'#404040',400:'#525252',500:'#737373',600:'#a3a3a3',700:'#d4d4d4',800:'#e5e5e5',900:'#f5f5f5',950:'#fafafa'},
        surface: {0:'#000000',50:'#0a0a0a',100:'#171717',200:'#262626',300:'#404040',400:'#525252',500:'#737373',600:'#a3a3a3',700:'#d4d4d4',800:'#e5e5e5',900:'#f5f5f5',950:'#ffffff'}
      }
    }
  }
});

// Zinc Preset
export const ZincPreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {50:'#fafafa',100:'#f4f4f5',200:'#e4e4e7',300:'#d4d4d8',400:'#a1a1aa',500:'#71717a',600:'#52525b',700:'#3f3f46',800:'#27272a',900:'#18181b',950:'#09090b'},
        surface: {0:'#ffffff',50:'#fafafa',100:'#f4f4f5',200:'#e4e4e7',300:'#d4d4d8',400:'#a1a1aa',500:'#71717a',600:'#52525b',700:'#3f3f46',800:'#27272a',900:'#18181b',950:'#09090b'}
      },
      dark: {
        primary: {50:'#09090b',100:'#18181b',200:'#27272a',300:'#3f3f46',400:'#52525b',500:'#71717a',600:'#a1a1aa',700:'#d4d4d8',800:'#e4e4e7',900:'#f4f4f5',950:'#fafafa'},
        surface: {0:'#000000',50:'#09090b',100:'#18181b',200:'#27272a',300:'#3f3f46',400:'#52525b',500:'#71717a',600:'#a1a1aa',700:'#d4d4d8',800:'#e4e4e7',900:'#f4f4f5',950:'#ffffff'}
      }
    }
  }
});

// Gray Preset
export const GrayPreset = definePreset(Aura, {
  components: {
    ...components,
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {50:'#f9fafb',100:'#f3f4f6',200:'#e5e7eb',300:'#d1d5db',400:'#9ca3af',500:'#6b7280',600:'#4b5563',700:'#374151',800:'#1f2937',900:'#111827',950:'#030712'},
        surface: {0:'#ffffff',50:'#f9fafb',100:'#f3f4f6',200:'#e5e7eb',300:'#d1d5db',400:'#9ca3af',500:'#6b7280',600:'#4b5563',700:'#374151',800:'#1f2937',900:'#111827',950:'#030712'}
      },
      dark: {
        primary: {50:'#030712',100:'#111827',200:'#1f2937',300:'#374151',400:'#4b5563',500:'#6b7280',600:'#9ca3af',700:'#d1d5db',800:'#e5e7eb',900:'#f3f4f6',950:'#f9fafb'},
        surface: {0:'#000000',50:'#030712',100:'#111827',200:'#1f2937',300:'#374151',400:'#4b5563',500:'#6b7280',600:'#9ca3af',700:'#d1d5db',800:'#e5e7eb',900:'#f3f4f6',950:'#ffffff'}
      }
    }
  }
});

